import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const includes = ['Qué darle y qué evitar — sin dudas', 'Cuánto darle según su peso', 'Cómo armar un plato balanceado completo sin conocimientos de nutrición', 'Cómo hacer el cambio sin riesgos', 'Recetas listas en menos de 20 minutos'];
export function ProductBreakdown() {
  return <section className="py-8 md:py-10 px-4 bg-cream" data-id="element-163">
      <div className="max-w-4xl mx-auto" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-6" data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-166">
            Dentro de Nutrición Canina Fácil vas a encontrar:
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-full" data-id="element-167"></div>
        </motion.div>

        <div className="bg-white rounded-3xl shadow-soft p-8 md:p-12 border border-sage" data-id="element-168">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-169">
            {includes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start" data-id="element-170">
                <div className="mt-1 bg-sage rounded-full p-1 flex-shrink-0 mr-4" data-id="element-171">
                  <CheckIcon className="w-5 h-5 text-primary" data-id="element-172" />
                </div>
                <span className="text-lg text-gray-700 font-medium" data-id="element-173">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}